import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAdmin } from '../contexts/AdminContext';

const AdminRoute = ({ children }) => {
  const { admin } = useAdmin();
  const loc = useLocation();
  if (!admin) return <Navigate to="/admin/login" state={{ from: loc.pathname }} replace />;
  return children;
};

export default AdminRoute;
